import request from "root/js/request";

export const getProductCardIncomingOrdersTable = async ({
  cabinet_id__in,
  date_from,
  date_to,
  period,
  in_product_id,
  in_product_id__in,
  extra_fields,
  source,
  source__in,
  warehouse__in,
  limit,
  group_by,
  order_by,
  offset,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/card_incoming_orders_table/",
    method: "get",
    params: {
      cabinet_id__in,
      date_from,
      date_to,
      period,
      in_product_id,
      in_product_id__in,
      extra_fields,
      source,
      source__in,
      warehouse__in,
      group_by,
      order_by,
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
